import StandardTabPanel from "../../../../../components/ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../../../components/ui library/components/tab-panels/standard/tab-header/tab-styles";

export default function Navigation({ _case, activeTab, children }) {
  const allTabs = [
    {
      key: "general",
      name: "General",
      isDisabled: true,
      permission: null,
      href: `/client-detail/${_case.id}/case/general`,
    },
    {
      key: "coverage-and-liability",
      name: "Coverage and Liability",
      isDisabled: true,
      permission: null,
      href: `/client-detail/${_case.id}/case/coverage-and-liability`,
    },
    {
      key: "policy-and-med-limits",
      name: "Policy and Med Limits",
      isDisabled: true,
      permission: null,
      href: `/client-detail/${_case.id}/case/policy-and-med-limits`,
    },
    {
      key: "property-damage",
      name: "Property Damage",
      isDisabled: true,
      permission: null,
      href: `/client-detail/${_case.id}/case/property-damage`,
    },
    {
      key: "expenses",
      name: "Expenses",
      isDisabled: true,
      permission: null,
      href: `/client-detail/${_case.id}/case/expenses`,
    },
    {
      key: "summary",
      name: "Summary",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/case/summary`,
    },
  ];

  return (
    <StandardTabPanel activeTab={activeTab} tabList={allTabs} headerTabSx={TAB_STYLES.SUB_TAB.SX} headerTabIndicatorSx={TAB_STYLES.SUB_TAB.TAB_INDICATOR_SX} >
      <section className="p-4 min-h-[90vh]">
        {children}
      </section>
    </StandardTabPanel>
  );
}
